import React, { Component } from 'react'
import { connect } from 'react-redux'

import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import Divider from 'material-ui/Divider'

import Badge from 'components/Badge'
import ButtonCard from './ButtonCard'

import sectionsActions from 'actions/sections'

let select = (state, props) => ({
	expanded: state.sections[props.id] !== undefined ? state.sections[props.id] : true
})

export class Section extends Component{
	render(){
		let { props } = this
		return(
			<div className="Section" style={{marginBottom: props.expanded?"10px":"0", marginTop:props.expanded && !props.top?"10px":"0"}}>
				<Divider style={{margin: "0"}}/>
				<Card
					style={{
						boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)"
					}}
					expanded={props.needBeExpanded || props.expanded}
					onExpandChange={(expanded)=> props.SECTION_EXPAND({section: props.id, expanded:props.alwaysExpanded || expanded})}
				>
					<CardHeader
						titleStyle={{padding:"0"}}
						title={
							<table style={{width:"calc(100% + 30px)", height: "52px"}}>
								<tr>
									<td
									style={{
										cursor:"pointer"
									  , padding: "16px"
									  , whiteSpace: "nowrap"
									}}
									onClick={(expanded)=>props.SECTION_EXPAND({section: props.id, expanded:props.alwaysExpanded || expanded})}>
										{props.title}
										{props.badge!==undefined &&
											<span
												style={{
													height: "20px"
													, position:"absolute"
													, top:"17px"
												}}
											>
												<Badge
						   							 badgeContent={props.badge}
						   							 secondary={props.badge>0}
					   						 	/>
											</span>
										}
									</td>
									<td style={{width:"100%", cursor:"pointer"}}
										onClick={(expanded)=>props.SECTION_EXPAND({section: props.id, expanded:props.alwaysExpanded || expanded})}
									></td>
									<td style={{padding: "16px 0", whiteSpace: "nowrap"}}>
										{props.rightButton}
									</td>
								</tr>
							</table>
						}
						textStyle={{width: "100%"}}
						style={{padding:"0px"}}
						showExpandableButton={true}
					/>
					<CardText expandable={true} style={{marginTop:"-20px", marginBottom:"-20px"}}>
						{props.children}
					</CardText>
				</Card>
			</div>
		)
	}
}

export default connect(select, sectionsActions)(Section)



// WEBPACK FOOTER //
// ./src/components/Section.js